import { useNaptime } from 'bundles/naptimejs';
import EnterprisePermittedProductsV1 from 'bundles/naptimejs/resources/enterprisePermittedProducts.v1';

export const usePermittedProducts = (programId?: string) => {
  const {
    data: { permittedProducts },
    pending: loading,
  } = useNaptime<{ permittedProducts: EnterprisePermittedProductsV1 }>(
    () => ({
      permittedProducts: programId
        ? EnterprisePermittedProductsV1.get(`Program~${programId}`, { fields: ['accessType'] })
        : undefined,
    }),
    [programId]
  );

  return {
    permittedProducts,
    loading,
  };
};
